/**
 * created by xcc on 2022/5/17
 * 网站扩展字段页面
 */
import React, {Component} from 'react';
import {Table, Select, Button, Pagination} from "antd";
import {message} from "../sysManagement/utils/sysManagementUtils";
import {Scrollbars} from "react-custom-scrollbars";
import $ from "jquery";
import {getListData, getWebsites, updateExtensionField} from "./websiteExtensionField";

const {Option} = Select;
let height = window.innerHeight - 96;

class WebsiteExtensionField extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            size: 10,
            total: 0,
            listData: [],  //列表数据
            websitesList: [], //站群数据
            clientId: "",
            hideOnSinglePage: true
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        //获取站群
        this.getSiteGroup();
        //事件监听
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        window.location.reload();   //重新加载页面，类似f5刷新
    }

    componentWillUnmount() {
        // 一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
        window.removeEventListener('resize', this.resize);
    }

    /**
     * 站群
     **/
    getSiteGroup() {
        let params = {
            keywords: '',
            page: 1,
            size: 10,
        }
        getWebsites(params, (data) => {
            let websitesList = [];
            if (data && data.data && data.data.length > 0) {
                websitesList = data.data;
                this.state.clientId = websitesList[0].id;
            }
            this.setState({
                websitesList
            }, () => {
                //网站扩展字段列表
                this.getExtensionFieldList();
            });
        });
    }

    /**
     * 获取网站扩展字段列表数据
     */
    getExtensionFieldList() {
        let params = {
            page: this.state.page,
            size: this.state.size,
            clientId: this.state.clientId
        };
        getListData(params, (res) => {
            let listData = [];
            let total =0;
            let hideOnSinglePage = true;
            if(res && res.data && res.data.length > 0){
                total = res.count;
                hideOnSinglePage = false;
                listData = res.data;
            }
            this.setState({
                listData,
                total,
                hideOnSinglePage
            }, () => {
                $('.ant-pagination-options-quick-jumper').find("input").val("");
            })
        })
    }

    /**
     * 渲染
     */
    render() {
        return (
            <div style={{margin: 15}}>
                <div style={{
                    width: "100%",
                    height: height,
                }}>
                    {/*渲染头部*/}
                    {this.renderHeader()}
                    {/*渲染内容*/}
                    {this.renderTable()}
                </div>
            </div>
        )
    }

    renderHeader() {
        return (
            <div style={{background: 'white', padding: "24px 15px",borderRadius:"5px 5px 0 0"}}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                }}>
                    <span style={{fontSize: 14, fontWeight: 400}}>切换站群： </span>
                    <Select placeholder={"请选择"}
                            className={"websiteSelect"}
                            value={this.state.clientId}
                            style={{width: 320, marginRight: 20}}

                            onChange={(e) => {
                                this.state.clientId = e;
                                this.setState({},()=>{
                                    this.getExtensionFieldList();
                                })
                            }}>
                        {this.state.websitesList && this.state.websitesList.length > 0 && this.state.websitesList.map((item, i) => {
                            return (
                                <Option key={i} value={item.id}>{item.webSiteUrl}</Option>
                            )
                        })}
                    </Select>
                    <style>{`.websiteSelect .ant-select-selection{border: 1px solid #EEF2FB; background-color: rgba(246, 248, 253, 0.39);}`}</style>
                    <Button style={{marginRight: "20px"}} onClick={() => {
                        this.synchronize()
                    }} type={"primary"}>
                        同步
                    </Button>
                </div>
            </div>
        )
    }

    synchronize() {
        let params = {
            clientId: this.state.clientId,
        }
        window.loading.show();
        updateExtensionField(params, (data,status) => {
            window.loading.hide();
            if (status === 200) {
                message.success("同步成功");
            }
            //网站扩展字段列表
            this.getExtensionFieldList();
        });
    }

    renderTable() {
        const columns = [
            {
                title: '媒体名称',
                key: 'userName',
                ellipsis: true,
                render: (record) => {
                    return (
                        <div className={"userName"} title={record.mediaName} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}>{record.mediaName}
                            <style>{`.userName .tabList .ant-table-thead > tr > th:first-child, .ant-table-tbody > tr td:first-child{
    padding: 16px 16px 16px 16px;overflow-wrap: break-word;}`}</style>
                        </div>
                    )
                }
            },
            {
                title: '栏目名称',
                dataIndex: 'treeName',
                key: 'treeName',
                ellipsis: true,
            },
            {
                title: '规则名称',
                key: 'extname',
                dataIndex: 'extname',
                ellipsis: true,
            },
            {
                title: '规则字段',
                key: 'fieldName',
                dataIndex: 'fieldName',
                ellipsis: true,
            },
            {
                title: '字段名称',
                key: 'fieldDispname',
                dataIndex: 'fieldDispname',
                ellipsis: true,
            },
            {
                title: '字段类型',
                key: 'fieldHtmltype',
                dataIndex: 'fieldHtmltype',
                ellipsis: true,
            },
            {
                title: '字段长度',
                key: 'fieldLength',
                dataIndex: 'fieldLength',
                ellipsis: true,
            }
        ];
        return (
            <div id="table" style={{background: 'white',borderRadius:"0 0 5px 5px"}}>
                <div style={{boxSizing:"border-box",padding:"0px 15px 10px"}}>
                    <Scrollbars autoHide autoHeight autoHeightMax={height - 149}>
                        <Table columns={columns} dataSource={this.state.listData} pagination={false}/>
                    </Scrollbars>
                </div>
                {this.state.listData && this.state.listData.length>0 ? <div style={{
                    padding: "10px",
                    display: "flex",
                    justifyContent: "flex-end",
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #e6e6e6",
                    borderRadius: "0 0 5px 5px"
                }}>
                    <Pagination
                        onChange={(page, pageSize) => {
                            this.paginationOnChange(page, pageSize)
                        }}//页码改变回调
                        onShowSizeChange={(page, pageSize) => {
                            this.state.hideOnSinglePage = false;
                            this.paginationOnChange(page, pageSize)
                        }}//每页条数改变回调
                        defaultCurrent={1}
                        defaultPageSize={10}
                        total={this.state.total}
                        showTotal={total => `共${total}条`}
                        current={this.state.page}
                        pageSize={this.state.size}
                        showSizeChanger
                        showQuickJumper
                        hideOnSinglePage={this.state.hideOnSinglePage}
                    />
                </div> : ""}

                <style>{`
                    #table .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #table .ant-table-placeholder{border-bottom: 0;}
                `}</style>
            </div>
        )
    }

    paginationOnChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.getExtensionFieldList();
    }
}

export default WebsiteExtensionField;